import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SectionTitle from "../../SectionTitle";

const FullWidthContent = ({ data }) => {
  const {
    title,
    subTitle,
    content,
    textAlignment = "left",
    button,
    image,
  } = data;
  const imageData = image?.localFile
    ? getImage(image?.localFile?.childImageSharp?.gatsbyImageData)
    : null;
  return (
    <div className="flex flex-wrap">
      {title && (
        <h2
          className={`mb-6 w-full basis-full px-4 text-center font-openSans text-4xl text-secondary`}
        >
          {title}
        </h2>
      )}
      <div className="relative w-full basis-full">
        {imageData ? <GatsbyImage image={imageData} alt="" /> : null}
        <div
          className={`${
            imageData ? "absolute" : ""
          } top-0 left-0 z-10 flex h-full w-full flex-wrap ${
            textAlignment === "left"
              ? "items-end justify-start"
              : textAlignment === "center"
              ? "items-end justify-center"
              : textAlignment === "right" && "items-center justify-end"
          } p-8`}
        >
          <div
            className={`${
              textAlignment === "left" || textAlignment === "center"
                ? "w-full basis-full"
                : textAlignment === "right" &&
                  "w-full basis-full bg-primary p-8 lg:w-1/3 lg:basis-1/3"
            }`}
          >
            <SectionTitle
              title={subTitle}
              color={imageData ? "white" : "secondary"}
              weight="bold"
              className={`mb-4 ${
                textAlignment === "left"
                  ? "text-left"
                  : textAlignment === "center"
                  ? "text-center"
                  : ""
              }`}
            />
            <div
              className={`page-content font-futura text-left text-xl 
                ${imageData ? "text-white" : ""}`}
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
            {button && (
              <a
                href={button.url}
                target={button.target}
                className="mt-4 inline-block rounded-xl bg-white px-10 py-2 font-openSans uppercase text-black"
              >
                {button.title}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullWidthContent;
